import {
  CalculateProfitLossPercent,
  FormatMoneyToDisplay,
} from '../../helper/currency-helper';
import { formatDateToStr } from '../../helper/date-helper';
import {
  TRADE_HISTORY_TABLE_HEADERS,
  TradeTransactionDisplay,
} from '../../models/tradeHistory';

const TradeHistoryTable = ({ transactions, onDeleteClick }: PropsType) => {
  return (
    <div className="mt-8 flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table className="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.entryTransactionId}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.exitTransactionId}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.company}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.ticker}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.action}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.quantity}
                </th>

                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 text-right"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.moneyIn}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 text-right"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.moneyOut}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.pnlAmt}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.pnlPercent}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.entryDate}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  {TRADE_HISTORY_TABLE_HEADERS.exitDate}
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  <span className="sr-only">Select</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {transactions.map((transaction) => (
                <tr
                  key={
                    transaction.entryTransactionID +
                    transaction.exitTransactionID
                  }
                >
                  <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0">
                    {transaction.entryTransactionID}
                  </td>
                  <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0">
                    {transaction.exitTransactionID}
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900">
                    {transaction.company}
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
                    {transaction.ticker}
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {transaction.action}
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {transaction.quantity}
                  </td>

                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500 text-right">
                    {transaction.entryPrice.toFixed(2)}
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500 text-right">
                    {transaction.exitPrice.toFixed(2)}
                  </td>
                  <td
                    className={`whitespace-nowrap px-2 py-2 text-sm text-right ${
                      transaction.profit >= 0
                        ? 'text-emerald-500'
                        : 'text-red-500'
                    }`}
                  >
                    {FormatMoneyToDisplay(transaction.profit)}
                  </td>
                  <td
                    className={`whitespace-nowrap px-2 py-2 text-sm text-right ${
                      transaction.profit >= 0
                        ? 'text-emerald-500'
                        : 'text-red-500'
                    }`}
                  >
                    {CalculateProfitLossPercent(
                      transaction.profit,
                      transaction.entryPrice
                    )}{' '}
                    %
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {formatDateToStr(transaction.entryDate)}
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {formatDateToStr(transaction.exitDate)}
                  </td>
                  <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    <button
                      type="button"
                      className="inline-flex items-center rounded-md bg-red-400 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

type PropsType = {
  transactions: TradeTransactionDisplay[];
  onDeleteClick: () => void;
};

export default TradeHistoryTable;
